import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

function ApiKeyField({ value, onChange, anotherSectionActive, apiKeyChanged, onChangeApiKeyClick, error, disabled }) {

    // useEffect(() => {
    //     validationService.validateNotEmpty(value, 'apiKey');
    //     return () => validationService.cleanValidation('apiKey');
    // }, [value])

    useEffect(() => {
        if (anotherSectionActive) {
            validationService.cleanValidation('apiKey');
        } else {
            validationService.validateNotEmpty(value, 'apiKey');
        }
        return () => validationService.cleanValidation('apiKey');
    }, [value, anotherSectionActive])

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="apikey">API Key <span className="modal-v2-required-mark">*</span></label>
                <div className="modal-v2-field-action-row">
                    <input className={`form-control oct_field ${error && 'border-danger'}`}
                        id="apikey"
                        type={"password"}
                        disabled={!apiKeyChanged}
                        value={value}
                        onChange={disabled ? null : event => onChange(event.target.value)} />
                    {!apiKeyChanged
                        && value
                        && <button type="button"
                            className="modal-v2-btn modal-v2-btn-primary modal-v2-inline-change-btn"
                            onClick={disabled ? null : () => onChangeApiKeyClick()}>
                            Change
                        </button>}
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("ApiKeyField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.apiKey
    }
}

export default connect(mapStateToProps)(ApiKeyField);
